import { Injectable, inject } from '@angular/core';

import { LocationsService } from '../services/locations/locations.service';

/**
 * Resolver to fetch all locations
 */
@Injectable()
export class LocationsResolver {
  private readonly locationsService = inject(LocationsService);


  resolve() {
    return this.locationsService.getLocations();
  }
}
